<template>
  <div :class="{ 'inactive-page': !page.isAdmin }" style="cursor: pointer">
    <v-avatar :size="60" color="grey lighten-4" style="border: 1px solid #eee">
      <BotLogoManager :bot="page">
        <template #logo="{ pageLogo }">
          <img :src="pageLogo" class="circle" alt />
        </template>
      </BotLogoManager>
    </v-avatar>
    <div class="page-detail">
      <slot name="page-status"></slot>
      <p class="page-name text-truncate">{{ page.name }}</p>

      <slot name="install-button"></slot>
    </div>
    <slot name="select-page"></slot>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data: function () {
    return {
      role: ''
    }
  },
  computed: {
    page: function () {
      let vm = this
      let page = this.value
      page.isAdmin = false
      vm.role = vm.$t('Administer')
      page.isAdmin = true
      return page
    }
  },
  methods: {
    onPageClick: function () {
      if (this.page.isAdmin) {
        this.$emit('onPageClick', this.page)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.inactive-page {
  opacity: 0.4 !important;
  background: #eee !important;
  cursor: not-allowed !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/allbots/PageItem.vue